import './Opportunities.css'
import CourseClassHeaderNavigation from '../../components/CourseClassHeaderNavigation/CourseClassHeaderNavigation'
import OpportunitiesCardContainer
    from '../../features/Opportunities/OpportunitiesCardContainer/OpportunitiesCardContainer'
import OpportunitiesCarousel from '../../features/Opportunities/OpportunitiesCarousel/OpportunitiesCarousel'
import MainLayout from '../../layouts/MainLayout/MainLayout'
import OpportunityModal from '../../features/Opportunities/OpportunityModal/OpportunityModal'
import useOpportunities from '../../hooks/useOpportunities'
import OpportunitiesSkeletonCard from '../../features/Opportunities/OpportunitiesSkeletonCard/OpportunitiesSkeletonCard'
import {IconMoodWrrr, IconReportSearch} from '@tabler/icons-react'
import { useConfigContext } from '../../contexts/ConfigContext/ConfigContextProvider'


export default function Opportunities() {

    const {
        bannerHighlight,
        restOfItems,
        isModal,
        selectedOportunity,
        handleClickCard,
        setIsModal,
        state
    } = useOpportunities()

    const { jsonTexts } = useConfigContext()
    const texts = jsonTexts?.oportunidades


    return (
        <MainLayout>
            <div className='OpportunitiesPage-wrapper'>
                <section className='OpportunitiesPage-container'>

                    {state.error &&
                    <>
                        <div className='OpportunitiesPage-error-container'>
                            < IconMoodWrrr color='var(--color-red)' size={150}/>
                            <p className='OpportunitiesPage-error--text'>{state.error}</p>
                        </div>
                    </>
                    }

                    {!state.error &&
                    <div className='OpportunitiesPage-header'>
                        < CourseClassHeaderNavigation noButton title={texts?.title}/>
                    </div>
                    }

                    {state.isLoading && < OpportunitiesSkeletonCard/>}

                    {!state.isLoading && !state.error &&
                    <>
                        {bannerHighlight.length !== 0 &&
                        < OpportunitiesCarousel itemsToMap={bannerHighlight} handleClickCard={handleClickCard}/>}

                  {restOfItems.length !== 0 && < OpportunitiesCardContainer handleClickCard={handleClickCard} itemsToMap={restOfItems} />}

                        {bannerHighlight.length === 0 && restOfItems.length === 0 &&
                        <div className='OpportunitiesPage-notResults-container'>
                            <p className='OpportunitiesPage-notResults--text'>{texts?.noContentText?.title}</p>
                            <p className='OpportunitiesPage-notResults--text'>{texts?.noContentText?.subtitle}</p>
                            < IconReportSearch size={125} className='OpportunitiesPage-notResults--icon'/>
                        </div>
                        }

                        {isModal && < OpportunityModal isModal={isModal} setIsModal={setIsModal}
                                                       selectedOportunity={selectedOportunity}/>}
                    </>
                    }

                </section>
            </div>
        </MainLayout>
    )
}
